import React, {useEffect, useRef, useState} from "react";
import {BookPubliCss} from "../css/Books.style";
import {useIsMobile} from "../../../hooks/useIsMobile";
import {ReactComponent as Top} from '../../../assets/top.svg';
import {useNavigate, Link} from "react-router-dom";

interface Props {
    onGenreSelect: (genre: string) => void;
    onLoadMore: () => void;
    bookCategory: any[];
}

const BookPubliList = ({ onGenreSelect, onLoadMore,  bookCategory }: Props) => {
    const isMobile = useIsMobile();
    const [selectedGenreIndex, setSelectedGenreIndex] = useState(0);
    const observerRef = useRef<HTMLDivElement | null>(null);
    const navigate = useNavigate();

    const genreList = [
        '시', '소설', '에세이', '인문',  '자기계발', '엽서/일러스트레이션 북'
    ]

    const handleClick = (index: number) => {
        setSelectedGenreIndex(index);
        const selectedGenre = genreList[index];
        onGenreSelect(selectedGenre);  // 상위 컴포넌트로 장르 전달
    };


    useEffect(() => {
        const currentElement = observerRef.current;
        if (!currentElement) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                     onLoadMore(); // 스크롤 하단 도달 시 onLoadMore 호출
                }
            },
            { threshold: 1.0 }
        );

        observer.observe(currentElement);

        return () => {
            observer.unobserve(currentElement);
        };
    }, [onLoadMore]);

    const handleBookDetail = (bookId : number) => {
        navigate(`/book/bookdetails/${bookId}`);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }


    return (

        <>

        {
            isMobile ?

                <div className="flex flex-col gap-6">
                    {/* 섹션 헤더 */}
                    <div className="flex flex-col gap-1">
                        <span className="text-[24px] font-bold text-black">모든 작품</span>
                    </div>

                    {/* 장르 필터 — 가로 스크롤 */}
                    <div
                        className="flex flex-row gap-2 overflow-x-auto pb-1"
                        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                    >
                        {genreList.map((title, idx) => (
                            <button
                                key={idx}
                                onClick={() => handleClick(idx)}
                                className="flex shrink-0 h-[34px] justify-center items-center px-4 rounded-full text-[13px] font-semibold transition-all"
                                style={{
                                    backgroundColor: selectedGenreIndex === idx ? '#19CF7A' : '#F5F5F5',
                                    color: selectedGenreIndex === idx ? '#FFF' : '#555555',
                                    border: selectedGenreIndex === idx ? 'none' : '1px solid rgba(224, 224, 224, 0.8)',
                                }}
                            >
                                {title}
                            </button>
                        ))}
                    </div>

                    {/* 도서 목록 */}
                    <div className="flex flex-col gap-4">
                        {bookCategory.map((list: any, idx: number) => (
                            <Link
                                key={idx}
                                to={`/book/bookdetails/${list.bookId}`}
                                className="flex flex-row gap-4 bg-white rounded-[16px] overflow-hidden cursor-pointer text-inherit no-underline"
                                style={{ boxShadow: '0px 2px 12px 0px rgba(0,0,0,0.07)', border: '1px solid rgba(229,236,232,0.8)' }}
                            >
                                {/* 책 표지 */}
                                <div className="w-[100px] shrink-0">
                                    <img
                                        className="w-full h-full object-cover"
                                        style={{ minHeight: '130px', maxHeight: '150px' }}
                                        src={
                                            list.coverImage
                                                ? `data:image/png;base64,${list.coverImage}`
                                                : `${process.env.PUBLIC_URL}/img/book_2.jpg`
                                        }
                                        alt={list.bookTitle}
                                    />
                                </div>

                                {/* 텍스트 */}
                                <div className="flex flex-col justify-center gap-2 py-4 pr-4 flex-1 min-w-0">
                                    <span className="text-[15px] font-bold text-black leading-[1.3] line-clamp-2">
                                        {list.bookTitle}
                                    </span>
                                    <span className="font-namsan text-[13px] text-[#6A6A6A] leading-[1.6] line-clamp-3">
                                        {list.bookPublicationReason}
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>

                    {/* TOP 버튼 */}
                    <div className="flex justify-end mt-2 mb-10">
                        <div
                            className="flex flex-col justify-center gap-0.5 w-14 h-14 cursor-pointer items-center bg-main rounded-full py-[6px] px-0"
                            onClick={scrollToTop}
                        >
                            <Top/>
                            <span className="text-white text-[13px]">TOP</span>
                        </div>
                    </div>

                    <div ref={observerRef} className="h-10"/>
                </div>


                :


                <div css={BookPubliCss}>
                    <div className={"items-center flex flex-col justify-center"}>
                        <div className={"genre"}>
                            {genreList.map((title, idx) => (
                                <button className={"genreBtn"} key={idx} onClick={() => handleClick(idx)}
                                        style={{
                                            backgroundColor: selectedGenreIndex === idx ? '#19CF7A' : '#F5F5F5',
                                            fontWeight : selectedGenreIndex === idx ? 'bold' : 400,
                                            color: selectedGenreIndex === idx ? '#FFF' : '#555555',
                                            border: selectedGenreIndex === idx ? 'none' : '1px solid #E0E0E0',
                                        }}>
                                    <span className={"text-sm"}>{title}</span>
                                </button>
                            ))}
                        </div>
                    </div>


                    <div className={"publiList"}>
                        {bookCategory.map((list: any, idx: number) => (
                            <div className={"publiItem"} key={idx}>



                                <div className={"publiReason"}>

                                        <span className={"text-[#8A8A8A] font-namsan text-sm font-normal"}>{list.bookTitle}</span>

                                    <span className="font-namsan text-base font-normal text-black">
                                          {
                                              list.bookPublicationReason.length > 90
                                                  ? list.bookPublicationReason.slice(0, 90) + '...'
                                                  : list.bookPublicationReason
                                          }</span>
                                </div>

                                <Link
                                    className="publiImg cursor-pointer block"
                                    to={`/book/bookdetails/${list.bookId}`}
                                >
                                    {list.coverImage ? (
                                        <img
                                            className="w-full h-full rounded-md shadow-book object-cover"
                                            src={`data:image/png;base64,${list.coverImage}` || `${process.env.PUBLIC_URL}/img/book_2.jpg`}
                                            alt={`Image ${idx}`}
                                        />
                                    ) : (
                                        <img
                                            className="w-full h-full object-cover"
                                            src={`${process.env.PUBLIC_URL}/img/book_2.jpg`}
                                            alt="책 이미지"
                                        />
                                    )}
                                </Link>


                            </div>
                        ))}
                    </div>


                    <div className="flex justify-end">
                        <div
                            className="flex flex-col justify-center gap-0.5 w-14 h-14  cursor-pointer items-center bg-main rounded-full py-[6px] px-0"
                            onClick={scrollToTop}
                        >
                            <Top/>
                            <span className="text-white text-[13px]">TOP</span>
                        </div>
                    </div>

                    <div ref={observerRef} className=""/>


                </div>
        }
        </>

    )
}

export default BookPubliList;
